// This is the first file that ReactNative will run when it starts up.
import App from "./app/app.tsx"
export default App
